module.exports = __webpack_public_path__ + "static/employee-time-clocks-d2dfc1386d591fda667dc33e5d1b8419.png";